import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URLS } from '../data/checkout';
const START_SECONDS = 23 * 3600 + 27 * 60 + 20;
const TAKEN_PERCENT = 68;
export function UrgencySection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(START_SECONDS);
  const units: Array<{
    value: string;
    label: string;
  }> = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <section className="w-full bg-petrol py-16 text-white sm:py-20" aria-labelledby="urgencia-title" data-id="element-344" data-mp="3b8sn9u939hh0">
      <div className="mx-auto grid max-w-5xl gap-10 px-5 sm:px-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,20rem)] lg:items-center" data-id="element-345" data-mp="3p80lokxfglk5">
        <div data-id="element-346" data-mp="1uusledqonhr4">
          <p className="inline-flex items-center gap-2 rounded-full bg-cta px-4 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-white" data-id="element-347" data-mp="1uu96z708rbhu">
            <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-348" data-mp="1qv0d8257bdma" />
            Ventana de lanzamiento
          </p>
          <h2 id="urgencia-title" className="mt-5 font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-349" data-mp="2srlbqn8nk5z6">
            Este precio existe hoy. Mañana puede no existir.
          </h2>
          <div className="mt-5 space-y-4 text-lg leading-relaxed text-white/85" data-id="element-350" data-mp="37j2gyw02bar7">
            <p data-id="element-351" data-mp="3chxcmyj4otsq">
              El precio de lanzamiento es <strong className="font-bold text-white" data-id="element-352" data-mp="3cgvp3ukxeeu4">$19.990 ARS</strong>.
              Cuando cierre esta ventana, sube $8.000 ARS de forma permanente.
            </p>
            <p data-id="element-353" data-mp="3lhtry9jmogb4">
              No es presión. Es la realidad del precio de lanzamiento: existe para quienes se mueven
              primero.
            </p>
          </div>
          <CtaButton href={CHECKOUT_URLS.megapack} className="mt-8" data-id="element-354" data-mp="1r4aq4nikebk0">
            Asegurar el precio de lanzamiento
          </CtaButton>
        </div>

        <div className="rounded-3xl bg-white p-6 text-body shadow-2xl" data-id="element-355" data-mp="1w46u4mr9i2zk">
          <p className="text-sm font-bold uppercase tracking-[0.12em] text-body-muted" data-id="element-356" data-mp="1o269oncpilhb">
            El precio de lanzamiento cierra en:
          </p>
          <div className="mt-4 flex gap-3" role="timer" aria-live="off" data-id="element-357" data-mp="1k2xerf5xkhk6">
            {units.map(unit => <div key={unit.label} className="flex-1 rounded-xl bg-beige px-2 py-4 text-center" data-id="element-358" data-mp="1xysvbecuxgke">
                <span className="block font-display text-3xl font-extrabold tabular-nums text-petrol sm:text-4xl" data-id="element-359" data-mp="1t3vjjzo70t3t">
                  {unit.value}
                </span>
                <span className="mt-1 block text-xs font-bold uppercase tracking-[0.14em] text-body-muted" data-id="element-360" data-mp="22z6z2k7fe4cm">
                  {unit.label}
                </span>
              </div>)}
          </div>

          <div className="mt-6" data-id="element-361" data-mp="2bt28i4fkygy2">
            <div className="h-3 w-full overflow-hidden rounded-full bg-beige" role="progressbar" aria-valuenow={TAKEN_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-362" data-mp="2qpkn7zmw3j1x">
              <div className="h-full rounded-full bg-cta" style={{
              width: `${TAKEN_PERCENT}%`
            }} data-id="element-363" data-mp="39ed8pk1fsj7u" />
            </div>
            <p className="mt-2.5 text-sm font-semibold text-body" data-id="element-364" data-mp="2vd0rz6egcdkw">
              {TAKEN_PERCENT}% de los cupos al precio de lanzamiento ya fueron tomados
            </p>
          </div>
        </div>
      </div>
    </section>;
}